const carouselIcon = {
    position: 'absolute',
    borderRadius: 'full',
    bgColor: 'orangeBaseColor',
    opacity: '0.8'
}

const getLightBoxChevronIcon = {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    bg: 'white',
    color: 'black',
    _hover: {bg: 'orange.500'},
    size: 'lg',
    borderRadius: 'lg',
    minWidth: 'initial'
}

export default {
    baseStyle: () => ({
        productImageSection: {
            float: {base: 'none', sm: 'left'},
            pr: {base: '0', md: '6'},
            flex: 1,
            overflowX: {base: 'initial', sm: 'auto', md: 'initial'}
        },
        gridItemBox: {
            position: 'relative',
            cursor: 'pointer',
            borderRadius: 'lg',
            overflow: 'hidden'
        },
        xMoreGridItemBox: {
            position: 'relative',
            cursor: 'pointer',
            border: '1px solid',
            borderColor: 'gray.200',
            borderRadius: 'md',
            overflow: 'hidden',
            _hover: {
                borderColor: 'orangeBaseColor'
            }
        },
        xMoreOverlay: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            bg: 'blackAlpha.600',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column'
        },
        xMoreOverlayNumber: {
            fontSize: '64px',
            fontWeight: 'bold',
            color: 'white'
        },
        productGlanceSection: {
            spacing: 0,
            width: {base: '100%', md: '52.5%'},
            float: {base: 'none', md: 'right'}
        },
        productTitle: {
            fontSize: {base: '18px', sm: '24px', lg: '32px'},
            lineHeight: {base: '23px', sm: '32px', lg: '40px'},
            fontWeight: 'extrabold',
            mt: {base: '4', md: '0'}
        },
        shopSeriesLink: {
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            fontSize: 'sm'
        },
        atcButton: {
            height: 12,
            minW: '180px',
            maxW: {base: '100%', lg: '416px'},
            py: 3,
            px: 6,
            lineHeight: 4
        },
        breadcrumbList: {
            direction: 'row',
            alignItems: 'baseline',
            gap: 0,
            mt: {base: 4, sm: 4, md: 6, xl: 8},
            mb: {base: 3, sm: 4, md: 6, xl: 8}
        },
        wishlistButton: {
            height: 12,
            width: {base: '100%', sm: 12},
            borderRadius: {base: '33px', sm: '50%'},
            border: '2px solid',
            borderColor: '#59595B',
            bgColor: 'white'
        },
        imageWishlistIcon: {
            cursor: 'pointer',
            position: 'absolute',
            backgroundColor: 'white',
            right: {base: '16px', sm: '14px', md: '16px'},
            top: {base: '16px', sm: '12px', md: '16px'},
            left: {base: 'auto', sm: '14px', md: 'auto'},
            border: '2px solid',
            borderColor: '#59595B',
            _hover: {
                borderColor: 'orangeBaseColor'
            },
            zIndex: 9,
            borderRadius: '50%',
            width: '40px',
            height: '40px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        },
        carouselIconPrev: {
            ...carouselIcon,
            left: '0'
        },
        carouselIconNext: {
            ...carouselIcon,
            right: '0'
        },
        enlargeIcon: {
            width: '40px !important',
            height: '40px !important',
            minWidth: 'inherit',
            borderRadius: 'full',
            position: 'absolute',
            bottom: '1rem',
            right: '1rem',
            bg: 'white',
            color: 'black',
            boxShadow: '0px 3px 7px -3px rgba(0, 0, 0, 0.30)',
            _hover: {
                bg: 'white'
            }
        },
        lightBoxCloseIcon: {
            color: 'white',
            size: 'lg',
            zIndex: 10,
            right: 8,
            top: 6,
            _hover: {
                bg: 'whiteAlpha.200'
            }
        },
        lightBoxBody: {
            p: 0,
            mt: {base: '0', md: '6'},
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative'
        },
        lightBoxThumbnailSection: {
            mt: {base: '4', lg: '8'},
            w: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative'
        },
        lightBoxThumbnailContainer: {
            gap: 4,
            overflowX: 'hidden',
            justifyContent: 'center',
            flexWrap: 'nowrap'
        },
        lightBoxThumbnail: {
            w: {base: '60px', sm: '120px'},
            h: {base: '60px', sm: '120px'},
            borderRadius: 'lg',
            overflow: 'hidden',
            cursor: 'pointer',
            flexShrink: 0,
            _hover: {
                opacity: 0.8,
                transition: 'all 0.2s'
            }
        },
        lightBoxImage: {
            w: '100%',
            h: '100%',
            borderRadius: '6px',
            objectFit: 'cover'
        },
        lightBoxChevronIconLarge: {
            ...getLightBoxChevronIcon,
            width: '48px',
            height: '48px'
        },
        lightBoxChevronIconSmall: {
            ...getLightBoxChevronIcon,
            width: '28px',
            height: '28px'
        },
        mobileCarouselBox: {
            w: '100%',
            cursor: 'pointer',
            borderRadius: 'lg',
            overflow: 'hidden',
            userSelect: 'none' // Prevent text selection during swipe
        },
        dotsIndicatorContainer: {
            position: 'absolute',
            bottom: '10px',
            w: '100%'
        },
        dotsIndicator: {
            justifyContent: 'center',
            alignItems: 'center',
            gap: 2
        },
        heroVideoBlock: {
            background: 'white',
            display: 'flex',
            alignItems: 'center',
            borderRadius: '4',
            height: {base: '343px', sm: '424px', xl: '640px'}
        },
        lightBoxVideo: {
            width: {base: '100%', sm: '75%', xl: '640px'},
            height: {base: '424px', xl: '500px'}
        }
    }),
    parts: ['imageWishlistIcon']
}
